import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { jwtDecode } from "jwt-decode";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Report from "./routes/Report";
import Login from "./routes/Login";
import Feed from "./routes/Feed";
import Profile from "./routes/Profile";
import SignUp from "./routes/SignUp";
import VerifyPhoneNumber from "./routes/VerifyPhoneNumber";
import VerifyPhoneNumberLogin from "./routes/VerifyPhoneNumberLogin";
import EnterName from "./routes/EnterName";
import Gender from "./routes/gender";
import DateOfBirth from "./routes/DateOfBirth";
import Ethnicity from "./routes/Ethnicity";
import SelectState from "./routes/SelectState";
import SelectInterests from "./routes/SelectInterests";
import EmailAddress from "./routes/EmailAddress";
import UploadProfilePicture from "./routes/UploadProfilePicture";
import TermsAndConditions from "./routes/TermsAndConditions";
import BrandCreate from "./routes/BrandCreate";
import AssetCreate from "./routes/AssetCreate";
import useToken from "./components/useToken";
import PrivateRoute from "./components/PrivateRoute";
import FeedConstruction from "./routes/FeedConstruction";
// import NewFeedConstruction from "./routes/NewFeedConstruction";
import FinalizeFeed from "./routes/FinalizeFeed";
import EncodeDecode from "./routes/encodedecode";
import AmbassadorProfiles from "./routes/AmbassadorProfiles";
import FeedSessionExport from "./routes/FeedSessionExport";
import ThankYouPage from "./routes/thankYouPage";
import EnterPassword from "./routes/EnterPassword";
import EnterUserName from "./routes/EnterUserName";
import LandingPage from "./routes/LandingPage";
import FeedStart from "./routes/FeedStart";
import FeedSelect from "./routes/FeedSelect";
import KeyFrameExtractor from "./routes/KeyFrameExtractor";
import UserReactions from "./routes/UserReactions";
import AssetReactions from "./routes/AssetReactions";
import UploadResume from "./routes/UploadResume";
import MainLayout from "./routes/MainLayout";
import UploadCalendar from "./routes/UploadCalendar";
import UserDashboard from "./routes/UserDashboard";
import ClassSchedule from "./routes/ClassSchedule";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import VerifySeller from "./routes/VerifySeller";
import SubscriptionStatus from "./routes/Subscription";
import SubscriptionGuard from "./components/SubscriptionGuard";
import AdminGuard from "./components/AdminGuard";
import SpecificFeedConstruction from "./routes/SpecificFeedConstruction";
import CoursePlanner from "./routes/CoursePlanner";

import SellerGuard from "./components/SellerGuard";
import RouteSwitcher from "./components/RouteSwitcher";
import RewardOptions from "./routes/RewardOptions";
import SellerDashboard from "./routes/SellerDashboard";
import LinkGenerator from "./routes/LinkGenerator";
import MarketPlace from "./routes/MarketPlace";
import StudyBuddy from "./routes/StudyBuddy";
import QuestionBoard from "./routes/QuestionBoard";

import UserImport from "./routes/UserImport";

import Transcript from "./routes/Transcript";
import Syllabus from "./routes/Syllabus";

import AdminPage from "./routes/AdminControl";
import ForgotPassword from "./routes/ForgotPassword";
import ResetPassword from "./routes/ResetPassword";
import SocialGlassFeed from "./SocialGlass/SocialGlassFeed";
import OrgCreate from "./routes/OrgCreate";
import CohortCreate from "./routes/CohortCreate";
import PromptCreate from "./routes/PromptCreate";
import UserCohortAssignment from "./routes/UserCohortAssignment";
import SumbitPost from "./components/Prompt";
import CohortGuard from "./CohortGuard";
import SocialGlassReport from "./SocialGlass/SocialGlassReport";

import SpeechAssessment from "./components/SpeechAssessment";
import CommaFeedConstruction from "./routes/CommaFeedConstruction";
import FeedConfiguration from "./routes/FeedConfiguration";
import ReportPage from "./components/ReportPage";
import ReportCreate from "./components/ReportCreate";
import Links from "./routes/UserOrgAssignment";
import SocialGlassGuard from "./components/SocialGlassGuard";
import LogoutButton from "./components/LogoutButton";
import FeedGuard from "./components/FeedGuard";
import CohortSelection from "./components/CohortSelection";
import PromptSelection from "./components/PromptSelection";
import DoctorOnboard from "./components/DoctorOnboard";
import SpeechDashboard from "./routes/SpeechDashboard";
import PatientProfile from "./components/PatientProfile";
import FeedSession from "./routes/FeedSession";
import ExportData from "./routes/DataDump";
import GenerateReport from "./routes/GenerateReport";
import PreferenceSelector from "./components/PreferenceSelector";
import SessionExpiredMessage from "./components/SessionExpiredMessage";
import MentorMenteeProgram from "./routes/MentorMenteeProgram";
import MentorDashboard from "./routes/MentorDashboard";
import BuyerProfile from "./routes/BuyerProfile";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function App() {
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  const routes = [
    { path: "/brandcreate", name: "Brand Create" },
    { path: "/assetcreate", name: "Asset Create" },
    { path: "/feedconstruction", name: "Feed Construction" },
  ];

  const SocialGlassRoutes = [
    { path: "/socialglass/orgcreate", name: "Create Organization" },
    { path: "/socialglass/cohortcreate", name: "Create Cohort" },
    { path: "/socialglass/promptcreate", name: "Create Prompt" },
    { path: "/socialglass/assigncohort", name: "Assign Cohort" },
    // { path: "/socialglass/selectcohort", name: "Feed View (Cohort)" },
    // { path: "/socialglass/selectprompt", name: "Feed View (Prompt)" },
    { path: "/socialglass/feedview", name: "Feed View" },
    { path: "/socialglass/links", name: "Session Links" },
    { path: "/socialglass/datadump", name: "Export Data" },
    { path: "/socialglass/editreport", name: "Customize Report" },
    // { path: "/socialglass/report", name: "Reports" },
  ];

  const { token, removeToken, setToken } = useToken();
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const storedToken = localStorage.getItem("token");

      if (storedToken && sessionExpired) {
        setSessionExpired(false);
      }

      if (!storedToken) {
        if (!sessionExpired) {
          setSessionExpired(false);
        }
        return;
      }

      try {
        const decoded = jwtDecode(storedToken);
        const currentTime = Date.now() / 1000;

        if (decoded.exp < currentTime) {
          removeToken();
          setSessionExpired(true);
        } else {
          setSessionExpired(false);
        }
      } catch (err) {
        console.error("Error decoding token", err);
        removeToken();
        setSessionExpired(true);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [removeToken, sessionExpired]);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      try {
        const decoded = jwtDecode(storedToken);
        const currentTime = Date.now() / 1000;
        if (decoded.exp > currentTime) {
          setSessionExpired(false);
        }
      } catch (err) {
        console.error("Error decoding token", err);
      }
    }
  }, []);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setSessionExpired(false);
    }
  }, [token]);

  return (
    <Router>
      <SessionExpiredMessage sessionExpired={sessionExpired} />
      <div className="App">
        {/* <img src={logo} alt="GenZ Logo" className="logo" loading="lazy"/> */}
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<LandingPage />} />
            <Route
              path="/login"
              element={
                <Login
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />
            <Route
              path="/signup"
              element={
                <Elements stripe={stripePromise}>
                  <SignUp
                    setToken={setToken}
                    token={token}
                    removeToken={removeToken}
                  />
                </Elements>
              }
            />
          </Route>
          <Route path="/MentorMenteeProgram" element={<MentorMenteeProgram />} />
          <Route path="/MentorDashboard" element={<MentorDashboard />} />
          <Route path="/uploadresume" element={<UploadResume />} />
          <Route path="/VerifySeller" element={<VerifySeller />} />
          <Route path="/planner" element={<CoursePlanner />} />
          <Route path="/speech" element={<SpeechAssessment />} />
          <Route path="/SocialGlass" element={<SocialGlassFeed />} />
          <Route path="/socialglass/report" element={<SocialGlassReport />} />
          <Route
            path="/SocialGlass"
            element={
              <PrivateRoute token={token}>
                <SocialGlassGuard>
                  {/* Flex container for both RouteSwitcher and LogoutButton */}
                  <div className="flex w-full items-center justify-between bg-gray-200 p-8">
                    {/* RouteSwitcher */}
                    <div className="flex-grow">
                      <RouteSwitcher routes={SocialGlassRoutes} />
                    </div>

                    {/* LogoutButton */}
                    <div className="">
                      <LogoutButton closeModal={closeModal} />
                    </div>
                  </div>
                </SocialGlassGuard>
              </PrivateRoute>
            }
          >
            <Route
              path="orgcreate"
              element={
                <OrgCreate
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />

            <Route
              path="links"
              element={
                <Links
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />
            <Route
              path="cohortcreate"
              element={
                <CohortCreate
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />
            <Route
              path="promptcreate"
              element={
                <PromptCreate
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />
            <Route
              path="assigncohort"
              element={
                <UserCohortAssignment
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />
            {/* <Route
              path="selectcohort"
              element={<CohortSelection setToken={setToken} token={token} removeToken={removeToken} />}
            />
            <Route
              path="selectprompt"
              element={<PromptSelection setToken={setToken} token={token} removeToken={removeToken} />}
            /> */}
            <Route
              path="feedview"
              element={
                <PreferenceSelector
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />
            <Route
              path="datadump"
              element={
                <ExportData
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />
            <Route
              path="editreport"
              element={
                <GenerateReport
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />
          </Route>
          <Route
            path="/verifyphonenumber"
            element={
              <VerifyPhoneNumber
                setToken={setToken}
                token={token}
                removeToken={removeToken}
              />
            }
          />
          <Route path="/UploadCalendar" element={<UploadCalendar />} />
          <Route path="/feed-session" element={<FeedSession />} />
          <Route path="/ClassSchedule" element={<ClassSchedule />} />
          <Route element={<CohortGuard />}>
            <Route path="/SubmitPost" element={<SumbitPost />} />
          </Route>
          <Route
            path="/CommaFeedConstruction"
            element={
              <PrivateRoute token={token}>
                <Navigate to="/CommaAssessmentCreation" replace />
              </PrivateRoute>
            }
          />
          <Route
            path="/CommaAssessmentCreation"
            element={
              <PrivateRoute token={token}>
                <CommaFeedConstruction
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              </PrivateRoute>
            }
          />
          <Route
            path="/verifyphonenumberLogin"
            element={
              <VerifyPhoneNumberLogin
                setToken={setToken}
                token={token}
                removeToken={removeToken}
              />
            }
          />
          <Route
            path="/enterusername"
            element={
              <PrivateRoute token={token}>
                <EnterUserName />
              </PrivateRoute>
            }
          />
          <Route
            path="/enterpassword"
            element={
              <PrivateRoute token={token}>
                <EnterPassword />
              </PrivateRoute>
            }
          />
          <Route
            path="/entername"
            element={
              <PrivateRoute token={token}>
                <EnterName />
              </PrivateRoute>
            }
          />
          <Route
            path="/gender"
            element={
              <PrivateRoute token={token}>
                <Gender />
              </PrivateRoute>
            }
          />
          <Route path="/transcript" element={<Transcript />} />
          <Route
            path="/marketplace"
            element={
              <PrivateRoute token={token}>
                <MarketPlace />
              </PrivateRoute>
            }
          />
          <Route path="/studybuddy" element={<StudyBuddy />} />
          <Route path="/syllabus" element={<Syllabus />} />
          <Route
            path="/QuestionBoard"
            element={
              <QuestionBoard
                setToken={setToken}
                token={token}
                removeToken={removeToken}
              />
            }
          />
          <Route
            path="/DateOfBirth"
            element={
              <PrivateRoute token={token}>
                <DateOfBirth />
              </PrivateRoute>
            }
          />
          <Route
            path="/Ethnicity"
            element={
              <PrivateRoute token={token}>
                <Ethnicity />
              </PrivateRoute>
            }
          />
          <Route
            path="/SelectState"
            element={
              <PrivateRoute token={token}>
                <SelectState />
              </PrivateRoute>
            }
          />
          <Route
            path="/SelectInterests"
            element={
              <PrivateRoute token={token}>
                <SelectInterests />
              </PrivateRoute>
            }
          />
          <Route
            path="/EmailAddress"
            element={
              <PrivateRoute token={token}>
                <EmailAddress />
              </PrivateRoute>
            }
          />
          <Route
            path="/UploadProfilePicture"
            element={
              <PrivateRoute token={token}>
                <UploadProfilePicture />
              </PrivateRoute>
            }
          />
          <Route
            path="/TermsAndConditions"
            element={
              <PrivateRoute token={token}>
                <TermsAndConditions
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              </PrivateRoute>
            }
          />
          <Route
            path="/feed"
            element={
              <FeedGuard token={token}>
                <Feed
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              </FeedGuard>
            }
          />
          <Route path="/EncDec" element={<EncodeDecode />} />
          <Route path="/AmbassadorProfiles" element={<AmbassadorProfiles />} />
          <Route path="/FeedSessionExport" element={<FeedSessionExport />} />
          <Route path="/thankyou" element={<ThankYouPage />} />
          <Route path="/KeyFrameExtractor" element={<KeyFrameExtractor />} />
          <Route path="/LinkGenerator" element={<LinkGenerator />} />
          <Route path="/UserImport" element={<UserImport />} />
          <Route path="/ReportPage" element={<ReportPage />} />
          <Route
            path="/SpeechDashboard"
            element={<Navigate to="/CommaDashboard" replace />}
          />
          <Route path="/CommaDashboard" element={<SpeechDashboard />} />
          <Route path="/reportcreate" element={<ReportCreate />} />
          <Route element={<AdminGuard />}>
            <Route path="/Admin" element={<AdminPage />} />
          </Route>
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
          <Route
            path="/resetPassword/:email/:token"
            element={<ResetPassword />}
          />
          <Route element={<SellerGuard />}>
            {/* <Route path="/subscription" element={<SubscriptionStatus />} /> */}
            {/* <Route element={<SubscriptionGuard />}>  */}
            <Route path="/sellerdashboard" element={<SellerDashboard />} />
            <Route path="/reward" element={<RewardOptions />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/report" element={<Report />} />
            <Route path="/UserReactions" element={<UserReactions />} />
            <Route
              path="/UserDashboard"
              element={
                <UserDashboard
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />
            <Route
              path="/FeedSelect"
              element={
                <FeedSelect
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />

            <Route path="/AssetReactions" element={<AssetReactions />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/report" element={<Report />} />
            <Route element={<RouteSwitcher routes={routes} />}>
              <Route
                path="/brandcreate"
                element={
                  <PrivateRoute token={token}>
                    <BrandCreate
                      setToken={setToken}
                      token={token}
                      removeToken={removeToken}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="/assetcreate"
                element={
                  <PrivateRoute token={token}>
                    <AssetCreate
                      setToken={setToken}
                      token={token}
                      removeToken={removeToken}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="/FeedConstruction"
                element={
                  <PrivateRoute token={token}>
                    <FeedConstruction
                      setToken={setToken}
                      token={token}
                      removeToken={removeToken}
                    />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route
              path="/FinalizeFeed"
              element={
                <PrivateRoute token={token}>
                  <FinalizeFeed
                    setToken={setToken}
                    token={token}
                    removeToken={removeToken}
                  />
                </PrivateRoute>
              }
            />
            <Route
              path="/FeedStart"
              element={
                <PrivateRoute token={token}>
                  <FeedStart />
                </PrivateRoute>
              }
            />
            <Route
              path="/FeedSelect"
              element={
                <FeedSelect
                  setToken={setToken}
                  token={token}
                  removeToken={removeToken}
                />
              }
            />
            <Route
              path="/SpecificFeedConstruction"
              element={<SpecificFeedConstruction />}
            />
            {/* </Route> */}
          </Route>
          <Route path="/feed/configure" element={<FeedConfiguration />} />
          <Route path="/DoctorOnboard" element={<DoctorOnboard />} />
          <Route
            path="/patient/:patientId"
            element={
              <PrivateRoute token={token}>
                <PatientProfile />
              </PrivateRoute>
            }
          />
          <Route path="/buyerprofile" element={<BuyerProfile />} />
          <Route path="*" element={() => <div>404 Not Found</div>} />{" "}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
